import enhancedFetch from "Utils/enhancedFetch";
import { API_URL } from "Utils/envVariables";
import { FETCH_DEFAULT_CONFIGS, FETCH_DEFAULT_CONFIGS_TOKEN } from "../config";
import { OtpChannelValidationResponse, otpChannelValidationResponseDecoder, OtpValidationData } from "./interfaces";

export async function validateEmail(to: OtpValidationData["to"]): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/email/`, {
    ...FETCH_DEFAULT_CONFIGS,
    method: "POST",
    body: JSON.stringify({ to }),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validatePhone(to: `+1${string}`, channel: string): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/phone/`, {
    ...FETCH_DEFAULT_CONFIGS,
    method: "POST",
    body: JSON.stringify({ to, channel }),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validateClientEmail(uid: string, token: string): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/email-to-client/`, {
    ...FETCH_DEFAULT_CONFIGS,
    method: "POST",
    body: JSON.stringify({ uid, token }),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validateUserEmail(): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/email-to-user/`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(),
    method: "POST",
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validateClientPhone(
  channel: string,
  uid: string,
  token: string
): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/phone-to-client/`, {
    ...FETCH_DEFAULT_CONFIGS,
    method: "POST",
    body: JSON.stringify({ uid, token, channel }),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validateUserPhone(channel: string): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/phone-to-user/`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(),
    method: "POST",
    body: JSON.stringify({ channel }),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}

export async function validateOtp(otpValidationData: OtpValidationData): Promise<OtpChannelValidationResponse> {
  const response = await enhancedFetch(`${API_URL}/otp/validate/code/`, {
    ...FETCH_DEFAULT_CONFIGS,
    method: "POST",
    body: JSON.stringify(otpValidationData),
  });

  return otpChannelValidationResponseDecoder.verify(await response.json());
}
